<template>
  <section class="p-1">
    <v-card class="">
      <v-card-title class="d-flex justify-space-between p-0 m-0">
        <div class="ps-2 subtitle-1">Customers Search</div>
        <div>
          <bread-crumb :bread-crumbs="['Customers Search']" />
        </div>
      </v-card-title>
      <v-divider class="p-0 m-0 primary--text"></v-divider>
      <v-card-text class="pb-0">
        <v-container> </v-container>
        <v-card class="pa-2 bord-color" elevation="0" rounded outlined>
          <v-sheet
            class="v-sheet--offset ms-4 pt-1 text-center"
            elevation="0"
            outlined
            width="90px"
          >
            <p class="font-weight-bold">
              <v-icon small class="me-1" color="secondary">mdi-filter</v-icon
              >Filters
            </p>
          </v-sheet>
          <v-form ref="form" v-model="valid" class="px-2">
            <v-row row-gutters class="align-items-center">
              <v-col cols="12" lg="3" sm="6" xs="12">
                <v-radio-group
                  v-model="searchInputs.customer_type"
                  row
                  class="ma-0"
                  justify-center
                >
                  <template v-slot:label>
                    <div>Select user type:</div>
                  </template>
                  <v-radio label="All" value="ALL"></v-radio>
                  <v-radio label="Individual" value="IND"></v-radio>
                  <v-radio label="Business" value="BUS"></v-radio>
                </v-radio-group>
              </v-col>
              <v-col cols="12" lg="2" sm="6" xs="12">
                <v-autocomplete
                  :items="listOfFilters"
                  v-model="userSelectedFilter"
                  outlined
                  dense
                  hide-details
                  :rules="FieldRequired('Type')"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" lg="2" sm="6" xs="12" v-if="userSelectedFilter">
                <v-text-field
                  v-if="userSelectedFilter === 'Customer ID'"
                  placeholder="Enter Customer ID"
                  v-model="searchInputs.customer_id"
                  outlined
                  dense
                  hide-details
                  :rules="FieldRequired('Customer ID')"
                  :clearable="isFieldClearable('customer_id')"
                ></v-text-field>

                <v-text-field
                  v-if="userSelectedFilter === 'Customer Name'"
                  placeholder="Enter Customer Name"
                  v-model="searchInputs.customer_name"
                  outlined
                  dense
                  hide-details
                  :rules="FieldRequired('Customer Name')"
                  :clearable="isFieldClearable('customer_name')"
                ></v-text-field>

                <v-text-field
                  v-if="userSelectedFilter === 'ID Number'"
                  placeholder="Enter ID Number"
                  v-model="searchInputs.id_number"
                  outlined
                  dense
                  hide-details
                  :rules="FieldRequired('ID Number')"
                  :clearable="isFieldClearable('id_number')"
                ></v-text-field>

                <v-text-field
                  v-if="userSelectedFilter === 'Email ID'"
                  placeholder="Enter Email"
                  v-model="searchInputs.user_email"
                  outlined
                  dense
                  hide-details
                  :rules="FieldRequired('Email ID')"
                  :clearable="isFieldClearable('user_email')"
                ></v-text-field>
                <v-text-field
                  v-if="userSelectedFilter === 'Phone Number'"
                  placeholder="Enter Phone Number"
                  v-model="searchInputs.phone_number"
                  outlined
                  dense
                  hide-details
                  :rules="FieldRequired('Phone Number')"
                  :clearable="isFieldClearable('phone_number')"
                ></v-text-field>
              </v-col>

              <div class="d-flex mt-1">
                <div>
                  <v-btn
                    depressed
                    small
                    class="mx-2 ms-3 primary text-capitalize"
                    @click="getRemitteList()"
                    >Get Results</v-btn
                  >
                </div>
                <div>
                  <v-btn
                    depressed
                    small
                    class="mx-2 text-capitalize"
                    outlined
                    color="primary"
                    @click="clear"
                    >Clear</v-btn
                  >
                </div>
              </div>
            </v-row>
          </v-form>
        </v-card>
      </v-card-text>
      <v-card-text>
        <loading
          :active="isloadagents"
          :is-full-page="false"
          :opacity="0.7"
          color="#ff6b00"
        />
        <v-row row-gutters class="mt-3 mb-3">
          <v-spacer></v-spacer>
          <v-col cols="12" lg="4" xs="12">
            <v-btn depressed @click="downloadExcelsheet" color="primary" small
              ><v-icon small>mdi-file-excel-outline</v-icon>Export
            </v-btn>
          </v-col>
          <v-col cols="12" lg="4" xs="12"></v-col>
          <v-col cols="12" lg="4" xs="12">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Type here to filter the table data."
              single-line
              hide-details
              dense
              clearable
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>

      <!-- <v-card-text>
          <v-row row-gutters>
            <v-col cols="12" lg="8" xs="12"></v-col>
            <v-col cols="12" lg="4" xs="12">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Type here to filter the table data."
                single-line
                hide-details
                dense clearable
              ></v-text-field>
            </v-col>        
        </v-row>
        </v-card-text> -->

      <v-data-table
        fixed-header
        height="55vh"
        :headers="headers"
        :items="userList"
        :items-per-page="perPageSize"
        :search="search"
        loading-text="Please select the criteria to view records."
        no-data-text="Please select the criteria to view records."
        item-key="user_id"
        dense
      >
        <!-- show-select
          :single-select="singleSelect" -->
        <template v-slot:item.user_type="{ item }">
          <v-chip
            label
            small
            outlined
            :color="item.user_type == 'Individual' ? 'primary' : 'secondary'"
          >
            {{ item.user_type }}
          </v-chip>
        </template>

        <template v-slot:item.risk_status="{ item }">
          <v-chip
            v-if="item.risk_status"
            label
            small
            outlined
            :color="returnColor(item.risk_status)"
          >
            {{ item.risk_status }}
          </v-chip>
          <span v-else>{{ item.risk_status }}</span>
        </template>

        <template v-slot:item.Is_Negativelisted="{ item }">
          <v-icon :color="item.Is_Negativelisted === 2 ? 'red' : 'green'"
            >mdi-flag</v-icon
          >
        </template>

        <template v-slot:item.action="{ item }">
          <v-icon
            color="grey"
            title="View Details"
            class="mr-2"
            @click="nextpage(item)"
          >
            mdi-chevron-right-circle
          </v-icon>
          <!-- <v-btn
            @click="deleteItem(item)"
            small
            class="text-capitalize"
            depressed
            icon
            fab
            color="primary"
          >
            <v-icon small title="Delete " class="">
              mdi-trash-can-outline
            </v-icon>
          </v-btn> -->
        </template>
      </v-data-table>
    </v-card>
    <!-- Delete confirmation popup dialog -->
    <v-dialog persistent v-model="openDialog" width="500">
      <v-card>
        <v-card-title class="border border-bottom">Delete</v-card-title>
        <v-card-text class="h5 py-3"
          >Are you sure you want to delete this customer?</v-card-text
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            depressed
            small
            color="primary"
            outlined
            @click="deleteCustomerById"
          >
            <v-icon>mdi-check</v-icon>
          </v-btn>
          <v-btn depressed small color="primary" outlined @click="closeDelete()"
            ><v-icon>mdi-close</v-icon></v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </section>
</template>

<script>
import BreadCrumb from "@/components/navigations/BreadCrumb.vue";
import { FieldRequired } from "@/utils/validation.js";
import Loading from "vue-loading-overlay";
import { mapGetters } from "vuex";
import userService from "@/services/UserService/userService.js";
import alerts from "@/mixins/alerts";
export default {
  name: "Customer Search",
  mixins: [alerts],
  data: () => {
    return {
      FieldRequired,
      delete_customer_id: "",
      openDialog: false,
      itemsPerPage: "10",
      valid: true,
      headers: [
        { text: "Customer ID", value: "user_id" },
        { text: "Customer Name", value: "name" },
        { text: "Customer Type", value: "user_type" },
        { text: "ID Number", value: "id_number" },
        { text: "Nationality", value: "nationality" },
        // { text: 'Email ID', value: 'Email_ID', width: 200 },
        { text: "Partner", value: "partner_name" },
        { text: "Phone Number", value: "mobile_number" },
        { text: "Onboard Status", value: "kyc_status" },
        { text: "Account Status", value: "account_status" },
        { text: "Risk Status", value: "risk_status" },
        { text: "Risk Percentage (%)", value: "risk_percentage" },
        {
          text: "Navigation",
          value: "action",
          sortable: false,
          width: 150,
          align: "center",
        },
      ],
      userList: [],
      search: "",
      listOfFilters: [
        "Customer Name",
        "Customer ID",
        "ID Number",
        "Email ID",
        "Phone Number",
      ],
      userSelectedFilter: "Customer Name",
      isloadagents: false,
      skip: 0, // Initial skip value
      limit: 1000, // Initial limit value
      perPageSize: window.innerWidth < 1600 ? 10 : 15,
      searchInputs: {
        customer_type: "ALL",
      },
    };
  },
  components: {
    BreadCrumb,
    Loading,
  },
  computed: {
    ...mapGetters(["getpreviouspageState"]),
  },
  watch: {
    userSelectedFilter(val) {
      if (val === "Customer ID") {
        this.searchInputs.customer_name = null;
        this.searchInputs.id_number = null;
        this.searchInputs.user_email = null;
        this.searchInputs.phone_number = null;
      } else if (val === "Customer Name") {
        this.searchInputs.customer_id = null;
        this.searchInputs.id_number = null;
        this.searchInputs.user_email = null;
        this.searchInputs.phone_number = null;
      } else if (val === "ID Number") {
        this.searchInputs.customer_id = null;
        this.searchInputs.customer_name = null;
        this.searchInputs.user_email = null;
        this.searchInputs.phone_number = null;
      } else if (val === "Email ID") {
        this.searchInputs.customer_id = null;
        this.searchInputs.customer_name = null;
        this.searchInputs.id_number = null;
        this.searchInputs.phone_number = null;
      } else if (val === "Phone Number") {
        this.searchInputs.customer_id = null;
        this.searchInputs.customer_name = null;
        this.searchInputs.id_number = null;
        this.searchInputs.user_email = null;
      } else {
        this.searchInputs.customer_id = null;
        this.searchInputs.customer_name = null;
        this.searchInputs.id_number = null;
        this.searchInputs.user_email = null;
        this.searchInputs.phone_number = null;
      }
      this.$refs.form.resetValidation();
    },
  },
  mounted() {
    this.logComponentPath();
    if (this.$refs.form) {
      this.$refs.form.resetValidation();
    }
  },

  methods: {
    deleteItem(item) {
      console.log(item);
      this.delete_customer_id = item.customer_id;
      this.openDialog = true;
    },
    closeDelete() {
      this.delete_customer_id = "";
      this.openDialog = false;
    },

    returnColor(val) {
      if (val.toLowerCase() == "medium") {
        return "orange";
      } else if (val.toLowerCase() == "high") {
        return "error";
      } else if (val.toLowerCase() == "low") {
        return "success";
      }
      return;
    },
    async downloadExcelsheet() {
      if (this.userList) {
        this.exportToExcel(this.headers, this.userList, "List of customers");
      }
    },
    logComponentPath() {
      const currentPath = this.$route.path;
      console.log("Current Component Path:", currentPath);
    },
    isFieldClearable(fieldName) {
      return (
        this.searchInputs[fieldName] !== "" &&
        this.searchInputs[fieldName] !== null
      );
    },
    clear() {
      for (const fieldName in this.searchInputs) {
        this.searchInputs[fieldName] = "";
        this.searchInputs.customer_type = "ALL";
        this.$refs.form.resetValidation();
      }
    },
    async deleteCustomerById() {
      this.isloadagents = true;
      try {
        const responseData = await userService.deleteCustomerById({
          customer_id: this.delete_customer_id,
        });
        if (responseData.data.status_code == 200) {
          this.isloadagents = false;
          this.showAlertSuccess(responseData.data.message);
          await this.getRemitteList();
          this.openDialog = false;
        } else {
          this.isloadagents = false;
          this.showAlertError(responseData.data.message);
        }
      } catch (err) {
        this.isloadagents = false;
        this.showAlertError("Failed: Something went wrong.");
        console.log(err);
      }
    },

    async getRemitteList() {
      const validate = this.$refs.form.validate();
      if (validate) {
        this.isloadagents = true;
        try {
          const params = {
            customer_type: this.searchInputs.customer_type
              ? this.searchInputs.customer_type
              : "ALL",
            customer_id: this.searchInputs.customer_id,
            customer_name: this.searchInputs.customer_name,
            id_number: this.searchInputs.id_number,
            user_email: this.searchInputs.user_email,
            phone_number: this.searchInputs.phone_number,
            skip: this.skip,
            limit: this.limit,
          };
          const response = await userService.getRemittenceList(params);
          if (response.status === 200) {
            this.isloadagents = false;
            this.userList = response.data.data;
            // to store the state of the page (handle page when route back )
            this.$store.dispatch("savePreviousPageState", {
              customer_type: this.searchInputs.customer_type
                ? this.searchInputs.customer_type
                : "ALL",
              customer_id: this.searchInputs.customer_id,
              id_number: this.searchInputs.id_number,
              user_email: this.searchInputs.user_email,
              phone_number: this.searchInputs.phone_number,
              customer_name: this.searchInputs.customer_name,
              limit: this.limit,
            });
          } else {
            this.isloadagents = false;
          }
        } catch (error) {
          this.isloadagents = false;
          console.error(error);
        }
      }
    },
    nextpage(item) {
      console.log("data ", item);
      this.$router.push({
        name: "List-Overview",
        query: {
          id: item.customer_id,
          login_id: item.login_id,
          customerid: item.customer_id,
          name: item.name,
          user_type: item.user_type,
          pin_no: item.txn_pin,
          risk_match_list: item.risk_match_list,
          percentage: item.risk_percentage,
        },
      });
      console.log("item", item);
      console.log("customer_id", item.customer_id);
      sessionStorage.setItem("addBeneInd", item.login_id);
      sessionStorage.setItem("Benecustomer_id", item.customer_id);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/global.scss";
.v-btn:not(.v-btn--round).v-size--default {
  height: 36px !important;
  min-width: 64px !important;
  padding: 0 16px !important;
}
.select-width {
  max-width: 60px;
}
.v-sheet--offset {
  top: -20px;
  width: 100px;
  height: 30px;
  position: relative;
  border-radius: 5px;
}
.bord-color {
  border-radius: 10px;
}
</style>
